import React from 'react';
import LegalLayout, { COMPANY } from './LegalLayout';

const Privacy = () => (
  <LegalLayout title="Privacy Policy" lastUpdated="29 May 2026">
    <p data-testid="privacy-intro">
      {COMPANY.name} respects your privacy. This Privacy Policy explains how we collect, use, share
      and safeguard the personal information you provide when you use the {COMPANY.shortName} Platform.
    </p>

    <h2>1. Information We Collect</h2>
    <ul>
      <li><strong>Account data</strong> — name, email, mobile number, password hash, traveller profile.</li>
      <li><strong>Booking data</strong> — passenger details (name, age, gender, passport when required), dates, suppliers, payment status.</li>
      <li><strong>Payment data</strong> — transaction identifiers from our PCI-DSS compliant payment partners (e.g. Razorpay). We do <em>not</em> store card numbers or CVVs.</li>
      <li><strong>Usage data</strong> — pages visited, search queries, device/browser, IP address, anonymised analytics events.</li>
    </ul>

    <h2>2. How We Use Your Information</h2>
    <ul>
      <li>To create, manage and confirm bookings on your behalf.</li>
      <li>To process payments and refunds.</li>
      <li>To send transactional emails (booking confirmations, voucher, refunds, alerts).</li>
      <li>To personalise offers, improve products and prevent fraud.</li>
      <li>To comply with applicable laws and respond to lawful requests.</li>
    </ul>

    <h2>3. Sharing of Information</h2>
    <p>We share the minimum information required with:</p>
    <ul>
      <li>Travel suppliers (airlines, hotels, bus operators) — to fulfil your booking.</li>
      <li>Payment gateways (Razorpay and equivalents) — to process payments.</li>
      <li>Communication providers (e-mail/SMS) — to deliver transactional messages.</li>
      <li>Government authorities — only as required by law.</li>
    </ul>
    <p>We <strong>never sell</strong> your personal data to marketers.</p>

    <h2>4. Cookies & Tracking</h2>
    <p>We use first-party cookies for authentication and necessary session data, and a limited set
      of analytics cookies (e.g. PostHog) to understand usage patterns. See our
      <a href="/cookie-policy"> Cookie Policy</a> for details and opt-out options.</p>

    <h2>5. Data Retention</h2>
    <p>Booking records are retained for at least 7 years to comply with financial and tax laws.
      Marketing preferences and analytics events are retained for up to 24 months unless you
      request deletion.</p>

    <h2>6. Your Rights</h2>
    <p>You have the right to access, correct, port and request deletion of your personal data,
      subject to applicable law. Email {COMPANY.email} with a verifiable request and we will
      respond within 30 days.</p>

    <h2>7. Security</h2>
    <p>We use industry-standard encryption (TLS in transit, AES-256/Fernet at rest for credentials),
      role-based access controls and regular security reviews. No method of transmission over the
      Internet is 100% secure, however.</p>

    <h2>8. Children's Privacy</h2>
    <p>The Platform is not intended for users under 18. Bookings on behalf of minors must be made
      by a parent or guardian.</p>

    <h2>9. Changes to this Policy</h2>
    <p>We may update this Policy from time to time. Material changes will be communicated by email
      or via a prominent notice on the Platform.</p>

    <h2>10. Contact</h2>
    <p>Data Protection Officer · {COMPANY.name}, {COMPANY.address}. Email {COMPANY.email}.</p>
  </LegalLayout>
);

export default Privacy;
